import React from 'react'
import { CobuText, CobuImage, CobuStack } from '@cobu/ui'
import { Strings } from '../../constants/Strings'

type ProfileHeaderProps = {
  user: any
  onPress?: () => void
}

export default function ProfileHeader({ user, onPress }: ProfileHeaderProps) {
  const first = user?.firstName || ''
  const last = user?.lastName || ''
  const fullName = `${first} ${user?.showFullName ? last : (last ? `${last[0]}.` : '')}`.trim()
  const buildingName = user?.building?.name || ''
  const initials = `${first?.[0] ?? ''}${last?.[0] ?? ''}`.trim() || 'Me'

  return (
    <CobuStack
      layout="horizontal"
      p="$4"
      mb="$3"
      mt="$3"
      ai="center"
      gap="$3"
      bg="$background"
      style={{
        cursor: onPress ? 'pointer' as const : 'default',
      }}
      onPress={onPress}
      role={onPress ? 'button' : undefined}
      tabIndex={onPress ? 0 : undefined}
    >
      {/* Profile Image */}
      <CobuStack
        w="$12"
        h="$12"
        br="$full"
        ai="center"
        jc="center"
        bg="$backgroundMuted"
        style={{ overflow: 'hidden' }}
      >
        {user?.profileImage || user?.profileImage ? (
          <CobuImage width={48} height={48} borderRadius={24} src={user?.profileImage || user?.profileImage} />
        ) : (
          <CobuText variant="heading" color="$cobuDarkBlue" fontSize={20 as any} fontWeight="regular">
            {initials}
          </CobuText>
        )}
      </CobuStack>

      {/* User Info */}
      <CobuStack f={1} gap="$0" ml="$3">
        <CobuText variant="body" fontWeight="regular" color="$cobuDarkBlue" fontSize={16 as any}>
          {fullName || user?.email || Strings.get().profile.header.fallbackName}
        </CobuText>
        {buildingName ? (
          <CobuText variant="caption" color="$cobuDarkBlue50" fontSize={12 as any} fontWeight="regular" mt="$0">
            {buildingName}
          </CobuText>
        ) : null}
      </CobuStack>

      {/* Chevron */}
      {onPress ? (
        <CobuText color="$lightBlueGray" fontSize={20 as any}>{'›'}</CobuText>
      ) : null}
    </CobuStack>
  )
}

function Avatar({ src, initials }: { src?: string; initials: string }) {
  if (src) {
    return <CobuImage width={56} height={56} borderRadius={28} src={src} />
  }
  return (
    <CobuStack w={56 as any} h={56 as any} br="$full" ai="center" jc="center" bg="$backgroundMuted">
      <CobuText variant="heading" color="$background" fontSize={20 as any}>{initials}</CobuText>
    </CobuStack>
  )
}


